import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { AnalysisMessageEntry } from "pokal_api"
import { RootState } from "./store/store"

// holds assistant replies pushed over the socket, keyed by conversationId, until
// useChatStream picks each one up and clears it
interface AnalysisMessageReadyState {
    ready: Record<string, AnalysisMessageEntry>
}

const name = "analysisMessageReadySlice"
const initialState: AnalysisMessageReadyState = {
    ready: {}
}

export const analysisMessageReadySlice = createSlice({
    name,
    initialState,
    reducers: {
        messageReady: (
            state,
            action: PayloadAction<{ conversationId: string; message: AnalysisMessageEntry }>
        ) => {
            state.ready[action.payload.conversationId] = action.payload.message
        },
        // called once useChatStream has applied the message, so it isn't reprocessed
        messageConsumed: (state, action: PayloadAction<{ conversationId: string }>) => {
            delete state.ready[action.payload.conversationId]
        }
    }
})

export const selectReadyMessage = (
    state: RootState,
    conversationId: string | null | undefined
): AnalysisMessageEntry | undefined =>
    conversationId ? state.analysisMessageReady.ready[conversationId] : undefined

export default analysisMessageReadySlice.reducer
